var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ob.wait || _vm.ob.message
    ? _c(
        "div",
        { staticClass: "wm__pered" },
        [
          _vm.ob.wait
            ? [_c(_setup.Dots, { staticClass: "wm__dots" })]
            : _vm._e(),
          _vm._v(" "),
          !_vm.ob.wait && _vm.ob.message
            ? _c("div", {
                staticClass: "wm__message",
                domProps: { textContent: _vm._s(_vm.ob.message) },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }